// Common colors
export const ICON_BACKGROUND_COLOR = '#FCC500'
export const ICON_COLOR = 'darkslategray'
export const CONTAINER_STYLE = {
    borderRadius: '5px',
    boxShadow: '0px 2px 92px 0px rgba(0, 0, 0, 0.20) !important',
    WebkitBoxShadow: '0px 2px 92px 0px rgba(0, 0, 0, 0.20) !important',
    MozBoxShadow: '0px 2px 92px 0px rgba(0, 0, 0, 0.20) !important'
};